import { bootstrapApplication } from '@angular/platform-browser';
import { answerRedirectBridge } from '@groundworks/ngx-groundworks-auth';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app';

// Silent-renewal iframes and popups must answer MSAL, then stop.
if (!answerRedirectBridge()) {
  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
}
